import Alert from '@mui/material/Alert';
import Grid from '@mui/material/Grid';
import { type SeedListData, segmentStatus } from '@openx/types/segments.ts';
import { isSoonToDate } from '@openx/utils/lib/date.ts';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

type SeedDetailsAlertsProps = {
  seeds: Pick<SeedListData, 'status' | 'expiration_date'>[] | null;
};

export const SeedDetailsAlerts = ({ seeds }: SeedDetailsAlertsProps) => {
  const { t } = useTranslation();

  const showWarningAlert = useMemo(() => {
    return seeds?.some(seed => seed.status === segmentStatus.EXPIRED || isSoonToDate(seed.expiration_date));
  }, [seeds]);

  if (!showWarningAlert) {
    return null;
  }

  return (
    <Grid size={6} sx={{ minWidth: 555 }}>
      <Alert severity="warning" sx={{ mb: 2 }}>
        {t(
          'Seed segments listed below may be expired, nearing expiration or contain errors, impacting LAL Segment generation. Please review before proceeding.'
        )}
      </Alert>
    </Grid>
  );
};
